import { render, staticRenderFns } from "./xzjyIndex.vue?vue&type=template&id=55ae0790&scoped=true&"
import script from "./xzjyIndex.vue?vue&type=script&lang=js&"
export * from "./xzjyIndex.vue?vue&type=script&lang=js&"
import style0 from "./xzjyIndex.vue?vue&type=style&index=0&id=55ae0790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ae0790",
  null
  
)

export default component.exports